module.exports = "mutation DeleteAttributeValue($attributeValueId:ID!){deleteAttributeValue(attributeValueId:$attributeValueId){success}}"